// extracted by css-extract-rspack-plugin
export default {"replies":"replies-enWOEs","link":"link-cCIXgm","text":"text-Zp5KXb"};